export const visit = (vm, at) => {
at({ "pl": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Niestety, ale nie byli\u015Bmy w stanie zweryfikowa\u0107 Twojego adresu e-mail." } } } });
};